import React, { Component } from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import solution1 from "../images/icon-solutions-01.svg";
import solution2 from "../images/icon-solutions-02.svg";
import solution3 from "../images/icon-solutions-03.svg";
import solution4 from "../images/icon-solutions-04.svg";
import HeroBanner from "./HeroBanner";

class Products extends Component {
  componentDidMount() {
    document.getElementById("root").classList.remove("welcome");
    document.getElementById("root").classList.remove("affiliate");
    document.getElementById("foo").classList.add("overflow");
  }
  render() {
    return (
      <div className="sub-page">
        <Helmet>
          <title>STech - Products</title>
          <meta name="description" content="STech - Products pages" />
        </Helmet>
        <header className="clearfix fadeInUp">
          <div className="container">
            <div className="left"></div>
            <div className="right">
              <h1>STech - The Expert on</h1>
              <h2>iGaming Solution</h2>
            </div>
          </div>
        </header>

        <section className="clearfix fadeInUp">
          <div className="container partners">
            <div className="left"></div>
            <div className="right">
              <div className="content">
                STech builds and develops cutting edge platforms for world-class
                online casinos and sportsbooks. With a top team of developers,
                programmers and designers, STech plans and executes i-Gaming
                brands and launches them with an experienced and all-round team
                of marketers and business leaders.
              </div>
            </div>
          </div>
        </section>
        <div className="container fadeInUp welcome p-hero">
          <HeroBanner />
        </div>
        <section className="clearfix fadeInUp">
          <div className="container">
            <div className="row">
              <div className="col">
                <img
                  src={solution4}
                  title="The Platform Solution"
                  alt="The Platform Solution"
                />
                <div>
                  <h2>The Platform Solution</h2>
                  <p>
                    The STech platform is one of a kind. A fast, secure and
                    scalable platform built for the future. The flexible and
                    adaptable platform brings a world-class offering to the
                    global iGaming industry.{" "}
                  </p>
                  <Link className="btn" to="/product/the-platform-solution">
                    <span>Learn More</span>
                  </Link>
                </div>
              </div>

              <div className="col">
                <img
                  src={solution3}
                  title="Powerful Products &amp; Partners"
                  alt="Powerful Products &amp; Partners"
                />
                <div>
                  <h2>Powerful Products &amp; Partners</h2>
                  <p>
                    Quality is one of the major cornerstones for us at STech
                    Technology. We live and breathe this motto and it also
                    reflects our carefully chosen products and partners.
                  </p>
                  <Link
                    className="btn"
                    to="/product/powerful-products-and-partners"
                  >
                    <span>Learn More</span>
                  </Link>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col">
                <img
                  src={solution1}
                  title="Omni-Channel is key"
                  alt="Omni-Channel is key"
                />
                <div>
                  <h2>Omni-Channel is key</h2>
                  <p>
                    A key for any brand is to give the customer a seamless and
                    effective path in the relationship with your brand. The
                    brands who can best use Omni-Channel data and understand all
                    customers are the winners. STech makes sure that it will be
                    the case.
                  </p>
                  <Link className="btn" to="/product/omni-channel">
                    <span>Learn More</span>
                  </Link>
                </div>
              </div>
              <div className="col">
                <img
                  src={solution2}
                  title="Marketing &amp; Operational Services"
                  alt="Marketing &amp; Operational Services"
                />
                <div>
                  <h2>Marketing &amp; Operational Services</h2>
                  <p>
                    Marketing Solutions: our team of experts have decades of
                    experience and knowledge from the industry and will guide
                    you in the direction you need.
                  </p>
                  <Link
                    className="btn"
                    to="/product/marketing-operational-services"
                  >
                    <span>Learn More</span>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

export default Products;
